import { ErrorBoundary } from 'components/common/error-boundary';
import { GameDataRouter } from 'components/sections/game-data/router';
import { PitchListHoC } from 'components/sections/pitch-list';
import { SEARCH_ID } from 'components/sections/pitch-list/store/definitions';
import { PitchListsHoC } from 'components/sections/pitch-lists';
import { PitchUploader } from 'components/sections/pitch-uploader';
import { PitchDesignRoute } from 'components/sections/pitches/router/pitch-design';
import { PLStoreMode } from 'lib_ts/enums/pitch-list.enums';
import { Navigate, Route, Routes } from 'react-router-dom';
import { paths, routePaths } from 'routes/paths';
import { useAuthStore } from 'stores/use-auth-store';

const RedirectToIndex = () => <Navigate to={paths.pitches.lists} replace />;

export const PitchesRouter = () => {
  const current = useAuthStore((s) => s.current);
  const isInGame = useAuthStore((s) => s.isInGame);

  return (
    <ErrorBoundary identifier="PitchesRouter">
      <Routes>
        <Route path="" element={<RedirectToIndex />} />

        <Route path={routePaths.pitches.lists} element={<PitchListsHoC />} />

        <Route
          path={routePaths.pitches.library}
          element={
            <PitchListHoC
              key={SEARCH_ID}
              identifier="LibraryPLHoC"
              mode={PLStoreMode.Library}
            />
          }
        />

        {/* new pitch, default list ID will be provided in fragment */}
        <Route
          path={routePaths.pitches.design}
          element={<PitchDesignRoute />}
        />

        <Route path={routePaths.pitches.upload} element={<PitchUploader />} />

        {current.mlb_stats_api && (
          <Route
            // GameDataRouter owns nested <Routes>; splat appended here (same as SectionRouter)
            path={`${routePaths.pitches.gameData}/*`}
            element={isInGame ? <RedirectToIndex /> : <GameDataRouter />}
          />
        )}

        <Route
          path={routePaths.pitches.list}
          element={
            <PitchListHoC
              identifier="ListPLHoC"
              mode={PLStoreMode.PitchList}
              // verbose
            />
          }
        />

        <Route path="*" element={<RedirectToIndex />} />
      </Routes>
    </ErrorBoundary>
  );
};
